var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('real-button',{class:_vm.classes,attrs:{"type":"program","state":_vm.state,"disabled":!_vm.$store.getters['atem/connected'](_vm.switcher)},on:{"click":_vm.runFade,"reghotkey":_vm.registerHotkey}},[_vm._v("FTB")])}
var staticRenderFns = []

export { render, staticRenderFns }